module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-schreibtisch-01.67a5bfe0.jpeg";